import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

const hexToRgba = (hex, alpha) => {
    if (!hex) return "transparent";
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const StatusDot = ({ statusKey, statusColors }) => {
    const color = statusColors?.[statusKey] || "#94a3b8";
    return (
        <span
            className="inline-flex h-4 w-4 items-center justify-center rounded-full"
            style={{ backgroundColor: hexToRgba(color, 0.2) }}
        >
            <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
        </span>
    );
};


const OrdersTable = ({ orders, onSelect, statusColors = {} }) => {
    const { t } = useTranslation();

    return (
        <div className="mt-8">
            <div className="hidden space-y-4 md:block">
                <div className="grid grid-cols-[1.2fr_1fr_0.6fr_1fr_0.6fr_32px] gap-4 px-4 text-xs text-slate-400">
                    <span>{t("GIFT_ORDERS_TABLE_ORDER_NUMBER")}</span>
                    <span>{t("COMMON_DATE")}</span>
                    <span>{t("COMMON_GIFTS")}</span>
                    <span>{t("COMMON_STATUS")}</span>
                    <span>{t("COMMON_COST")}</span>
                    <span />
                </div>
                {orders.map((order) => (
                    <button
                        key={order.id}
                        type="button"
                        onClick={() => onSelect(order)}
                        className="w-full rounded-2xl bg-[#f5f6fb] px-4 py-4 text-left text-sm transition hover:bg-[#eef1fb] grid grid-cols-[1.2fr_1fr_0.6fr_1fr_0.6fr_32px] items-center gap-4 focus:outline-none"
                    >
                        <span className="text-sm font-semibold text-primary">{order.displayId}</span>
                        <span className="text-xs text-slate-500">{order.date}</span>
                        <span className="text-xs text-slate-500">{order.gifts}</span>
                        <span className="flex items-center gap-2">
                            <StatusDot statusKey={order.statusKey} statusColors={statusColors} />
                            <span className="text-xs text-slate-500">{order.status}</span>
                        </span>
                        <span className="text-xs text-slate-500">{order.cost}</span>
                        <ArrowRight className="h-4 w-4 text-slate-400" />
                    </button>
                ))}
            </div>

            <div className="space-y-4 md:hidden">
                {orders.map((order) => (
                    <button
                        key={order.id}
                        type="button"
                        onClick={() => onSelect(order)}
                        className="w-full rounded-2xl bg-[#f5f6fb] px-4 py-4 text-left text-sm transition hover:bg-[#eef1fb] focus:outline-none"
                    >
                        <div className="flex items-center justify-between">
                            <span className="text-sm font-semibold text-primary">{order.displayId}</span>
                            <ArrowRight className="h-4 w-4 text-slate-400" />
                        </div>
                        <div className="mt-4 grid grid-cols-3 gap-4 text-xs text-slate-500">
                            <div>
                                <p className="text-[11px] text-slate-400">{t("COMMON_DATE")}</p>
                                <p>{order.date}</p>
                            </div>
                            <div>
                                <p className="text-[11px] text-slate-400">{t("COMMON_GIFTS")}</p>
                                <p>{order.gifts}</p>
                            </div>
                            <div>
                                <p className="text-[11px] text-slate-400">{t("COMMON_COST")}</p>
                                <p>{order.cost}</p>
                            </div>
                        </div>
                        <div className="mt-4 flex items-center gap-2">
                            <span className="text-[11px] text-slate-400">{t("COMMON_STATUS")}</span>
                            <StatusDot statusKey={order.statusKey} statusColors={statusColors} />
                            <span className="text-xs text-slate-500">{order.status}</span>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default OrdersTable;
